module.exports = __webpack_public_path__ + "static/diyanet1-94b8ec6549f20216c324b5802345939b.png";